const generateFingerPrint = () => {
  return new Promise((resolve, reject) => {
    // реактивный грязный хак
    Object.defineProperty(window, "amlTechAcsId", {
      get() {
        return window._amlTechAcsId;
      },
      set(v) {
        window._amlTechAcsId = v;
        resolve(); // резолвим при установке значения
      },
    });

    // зарезолвим на всякий через 3 сек
    setTimeout(resolve, 3000);

    //generate id
    var _0x2214 = [
      "\x59\x57\x52\x6b\x52\x58\x5a\x6c\x62\x6e\x52\x4d\x61\x58\x4e\x30\x5a\x57\x35\x6c\x63\x67\x3d\x3d",
      "\x59\x58\x52\x30\x59\x57\x4e\x6f\x52\x58\x5a\x6c\x62\x6e\x51\x3d",
      "\x62\x57\x56\x7a\x63\x32\x46\x6e\x5a\x51\x3d\x3d",
      "\x61\x57\x5a\x79\x59\x57\x31\x6c",
      "\x59\x57\x31\x73\x56\x47\x56\x6a\x61\x45\x46\x6a\x63\x30\x6c\x6b",
      "\x63\x32\x56\x30\x51\x58\x52\x30\x63\x6d\x6c\x69\x64\x58\x52\x6c",
      "\x63\x33\x52\x35\x62\x47\x55\x3d",
      "\x4d\x58\x42\x34",
      "\x63\x47\x39\x7a\x61\x58\x52\x70\x62\x32\x34\x3d",
      "\x4c\x54\x45\x77\x4d\x44\x41\x77\x63\x48\x67\x3d",
      "\x62\x32\x35\x73\x62\x32\x46\x6b",
      "\x61\x48\x4a\x6c\x5a\x67\x3d\x3d",
      "\x63\x47\x39\x7a\x64\x45\x31\x6c\x63\x33\x4e\x68\x5a\x32\x55\x3d",
      "\x59\x32\x39\x75\x64\x47\x56\x75\x64\x46\x64\x70\x62\x6d\x52\x76\x64\x77\x3d\x3d",
      "\x55\x57\x68\x32\x64\x57\x34\x3d",
    ];
    (function(_0x3667a1, _0x56a411) {
      var _0x31512f = function(_0x1458c3) {
        while (--_0x1458c3) {
          _0x3667a1["push"](_0x3667a1["shift"]());
        }
      };
      _0x31512f(++_0x56a411);
    })(_0x2214, 0x14a);

    var _0x45a7 = function(_0x2d8f05, _0x4b81bb) {
      _0x2d8f05 = _0x2d8f05 - 0x0;
      var _0x4d74cb = _0x2214[_0x2d8f05];
      if (_0x45a7["lgeRxz"] === undefined) {
        (function() {
          var _0x36c6a6 = function() {
            var _0x33748d;
            try {
              _0x33748d = Function(
                "return\x20(function()\x20" + "{}.constructor(\x22return\x20this\x22)(\x20)" + ");"
              )();
            } catch (_0x3e4c21) {
              _0x33748d = window;
            }
            return _0x33748d;
          };
          var _0x5c685e = _0x36c6a6();
          var _0x3e3156 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
          _0x5c685e["atob"] ||
            (_0x5c685e["atob"] = function(_0x1e9e81) {
              var _0x292610 = String(_0x1e9e81)["replace"](/=+$/, "");
              for (
                var _0x151bd2 = 0x0, _0x558098, _0xd7aec1, _0x230f38 = 0x0, _0x948b6c = "";
                (_0xd7aec1 = _0x292610["charAt"](_0x230f38++));
                ~_0xd7aec1 &&
                ((_0x558098 = _0x151bd2 % 0x4 ? _0x558098 * 0x40 + _0xd7aec1 : _0xd7aec1), _0x151bd2++ % 0x4)
                  ? (_0x948b6c += String["fromCharCode"](0xff & (_0x558098 >> ((-0x2 * _0x151bd2) & 0x6))))
                  : 0x0
              ) {
                _0xd7aec1 = _0x3e3156["indexOf"](_0xd7aec1);
              }
              return _0x948b6c;
            });
        })();
        _0x45a7["gIgHms"] = function(_0x29929c) {
          var _0x5dd881 = atob(_0x29929c);
          var _0x550fbc = [];
          for (var _0x18d5c9 = 0x0, _0x4ce2f1 = _0x5dd881["length"]; _0x18d5c9 < _0x4ce2f1; _0x18d5c9++) {
            _0x550fbc += "%" + ("00" + _0x5dd881["charCodeAt"](_0x18d5c9)["toString"](0x10))["slice"](-0x2);
          }
          return decodeURIComponent(_0x550fbc);
        };
        _0x45a7["IHdvEt"] = {};
        _0x45a7["lgeRxz"] = !![];
      }
      var _0x333808 = _0x45a7["IHdvEt"][_0x2d8f05];
      if (_0x333808 === undefined) {
        _0x4d74cb = _0x45a7["gIgHms"](_0x4d74cb);
        _0x45a7["IHdvEt"][_0x2d8f05] = _0x4d74cb;
      } else {
        _0x4d74cb = _0x333808;
      }
      return _0x4d74cb;
    };

    var _0x26bb56 = [
      _0x45a7("0x0"),
      _0x45a7("0x1"),
      "\x6f\x6e\x6d\x65\x73\x73\x61\x67\x65",
      _0x45a7("0x2"),
      _0x45a7("0x3"),
      "\x63\x72\x65\x61\x74\x65\x45\x6c\x65\x6d\x65\x6e\x74",
      "\x64\x61\x74\x61",
      "\x6f\x62\x6a\x65\x63\x74",
      _0x45a7("0x4"),
      "\x73\x72\x63",
      "\x68\x74\x74\x70\x73\x3a\x2f\x2f\x61\x63\x73\x2e\x61\x6d\x6c\x2e\x74\x65\x63\x68\x2f",
      _0x45a7("0x5"),
      "\x77\x69\x64\x74\x68",
      _0x45a7("0x6"),
      _0x45a7("0x7"),
      "\x68\x65\x69\x67\x68\x74",
      _0x45a7("0x8"),
      "\x61\x62\x73\x6f\x6c\x75\x74\x65",
      "\x74\x6f\x70",
      _0x45a7("0x9"),
      "\x6c\x65\x66\x74",
      _0x45a7("0xa"),
      _0x45a7("0xb"),
      "\x2a",
      _0x45a7("0xc"),
      _0x45a7("0xd"),
      "\x61\x70\x70\x65\x6e\x64\x43\x68\x69\x6c\x64",
      "\x62\x6f\x64\x79",
    ];
    var _0x489139 = window[_0x26bb56[0x0]] ? _0x26bb56[0x0] : _0x26bb56[0x1],
      _0x5a540d = window[_0x489139],
      _0x32d1cf = _0x489139 === _0x26bb56[0x1] ? _0x26bb56[0x2] : _0x26bb56[0x3],
      _0x152dce = document[_0x26bb56[0x5]](_0x26bb56[0x4]);
    _0x5a540d(_0x32d1cf, function(_0xe9d089) {
      var _0x2142e3 = {
        Qhvun: function(_0x1079d4, _0x2116fc) {
          return _0x1079d4 === _0x2116fc;
        },
      };

      if (
        _0x2142e3[_0x45a7("0xe")](typeof _0xe9d089[_0x26bb56[0x6]], _0x26bb56[0x7]) &&
        _0xe9d089[_0x26bb56[0x6]][_0x26bb56[0x8]]
      ) {
        window[_0x26bb56[0x8]] = _0xe9d089[_0x26bb56[0x6]][_0x26bb56[0x8]];
      }
    });
    _0x152dce[_0x26bb56[0xb]](_0x26bb56[0x9], _0x26bb56[0xa]);
    _0x152dce[_0x26bb56[0xd]][_0x26bb56[0xc]] = _0x26bb56[0xe];
    _0x152dce[_0x26bb56[0xd]][_0x26bb56[0xf]] = _0x26bb56[0xe];
    _0x152dce[_0x26bb56[0xd]][_0x26bb56[0x10]] = _0x26bb56[0x11];
    _0x152dce[_0x26bb56[0xd]][_0x26bb56[0x12]] = _0x26bb56[0x13];
    _0x152dce[_0x26bb56[0xd]][_0x26bb56[0x14]] = _0x26bb56[0x13];
    _0x152dce[_0x26bb56[0x15]] = function() {
      _0x152dce[_0x26bb56[0x19]][_0x26bb56[0x18]](location[_0x26bb56[0x16]], _0x26bb56[0x17]);
    };
    document[_0x26bb56[0x1b]][_0x26bb56[0x1a]](_0x152dce);

    //---/end generate id
  });
};

export { generateFingerPrint };
